import React from 'react';
import BaseTablePage from '../../elements/BaseTablePage'
import Pagination from '../../elements/Pagination'
import { RecieveSMSTableUI } from './RecieveSMSTableUI'

import { ReciveSMSSearchForm } from './ReciveSMSSearchForm'

//import { GhorePrizePage } from '../../components/GhorePrizePage'


export class RecieveSMSTable extends BaseTablePage {

  constructor(props) {
    super(props);
    this.getDataUrl = "api/v1/GetRecieveSMS?offset=";
    this.getExcelUrl = "/api/v1/GetRecieveSMSExcel";
    this.className = "RecieveSMS";
    this.state.mode = "table";
    this.state.searchData = {};

  }


  render() {
    //  if (!this.state.isLoaded) {
    //  return <div className="box-body"> در حال بارگذاری</div>;
    // }

    //console.log()
    return (
      <div className="container">
        <ReciveSMSSearchForm onSubmit={this.onSubmitSearchData} onExcelClick={this.onExcelButtonClick} searchData={this.state.searchData} />
        <RecieveSMSTableUI data={this.state.data} isReady={this.state.isReady} onViewClick={this.onViewClick} />
        <Pagination pageNumber={this.state.pageNumber} isReady={this.state.isReady} count={this.state.count} perPageCount={this.state.pageSize} onChange={this.handleChangePage} />
        
      </div>
    );
  }
}

//{this.state.isReady==false? "" : 
//        <div className="row">

//          <div className=" col-md-4" >

//            <div class="info-box">
//              <span class="info-box-icon bg-success"><i class="fa fa-flag-o"></i></span>

//              <div class="info-box-content">
//                <span class="info-box-text text-center">  تعداد شرکت کنندگان </span>
//                <span class="info-box-number text-center"> {this.state.distinctMobile}</span>
//              </div>
//            </div>
//          </div>

//          <div className=" col-md-4" >

//          </div>

//          <div className=" col-md-4"  >

//          <div class="info-box">
//              <span class="info-box-icon bg-danger"><i class="fa fa-star-o"></i></span>

//              <div class="info-box-content">
//                <span class="info-box-text text-center"> تعداد کدهای ارسالی </span>
//                <span class="info-box-number text-center">{this.state.successCode}</span>
//              </div>
              
//            </div>
//          </div>
//        </div>
//                }
                



// WEBPACK FOOTER //
// ./src/tables/recieveSMS/RecieveSMSTable.js